module.exports = __webpack_public_path__ + "img/shipyard_1.97a65984.webp";